export class WaitingMemberModel {
    constructor(memberData) {
        this._waitingMember = {
            fullName: memberData.fullname,
            email: memberData.email,
        };
    }

    get waitingMember() {
        return this._waitingMember;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/WaitingMemberModel.js